import { CopywritingSmall } from '../copywriting'
import { _AdvertiseImgAssembledBase } from './advertiseImgAssembledBase'

export class _AdvertiseImgAssembledSmall extends _AdvertiseImgAssembledBase {
  cssType: 'default' | 'small' = 'small'
  protected initPC(): this {
    this.copywriting = new CopywritingSmall()
    this['--advertse-img-assembled-width'] = '3.74rem'
    this['--advertse-img-assembled-height'] = '1.46rem'
    this['--advertse-img-assembled-padding'] = '0 0.05rem'
    this['--introduce-left-width'] = '1.7rem'
    this['--advertisement-image-width'] = '1.67rem'
    return this
  }
  protected initH5(): this {
    this.copywriting = new CopywritingSmall()
    this['--advertse-img-assembled-width'] = '5.2rem'
    this['--advertse-img-assembled-height'] = '2.04rem'
    this['--advertse-img-assembled-padding'] = '0 0.05rem'
    this['--introduce-left-width'] = '2.28rem'
    this['--advertisement-image-width'] = '2.34rem'
    return this
  }
}
